{
    "configUrl" : "/assets/config/config.json",
    "metadata" : "/api/partners/metadata",
    "login" : "/api/auth/login",
    "register" : "/api/users/register",
    "forgotPassword" : "/api/auth/forgot-password",
    "resetPassword" : "/api/auth/reset-password",
    "getPermissions" : "/api/partners/features",
    "rolePermissions" : "/api/partners/roleFeatures",
    "allUsers" : "/api/users",
    "locations" : "/api/common/locations",
    "logout" : "/api/auth/logout",
    "verifyEmail" : "/api/auth/verify-email",
    "changePassword" : "/api/users/change-password",
    "properties" : "/api/properties",
    "bills" : "/api/bills",
    "billCategories" : "/api/common/bill-categories",
    "adminBillCategories" : "/api/common/admin/bill-categories",
    "billImages" : "/api/common/signed-url",
    "inspections" : "/api/inspections",
    "service-requests" : "/api/service-requests",
    "notifications" : "/api/notifications",
    "amenities" : "/api/common/amenities",
    "enquiries" : "/api/enquiries",
    "leads" : "/api/leads",
    "tasks" : "/api/tasks",
    "tasksSummary" : "/api/tasks/summary",
    "tasksMyDay" : "/api/tasks/my-day",
    "tasksActivityLogs" : "/api/tasks/activity-logs",
    "tasksRecurrences" : "/api/tasks/recurrences",
    "usersPropertyRoles" : "/api/users/property-roles",
    "reports" : "/api/reports",
    "reportJobs" : "/api/reports/jobs",
    "adminItems" : "/api/common/admin/items",
    "documentTemplates" : "/api/templates/document",
    "notificationTemplates" : "/api/templates/notification",
    "bankAccounts" : "/api/bank-accounts",
    "agent" : "/api/agent"
}
